module.exports = __webpack_public_path__ + "static/media/pla_360_war_bea.ccc25b9b.png";